import React, { useState } from "react";

import {
  TextField,
  Button,
  Grid,
  Box,
  Paper,
  FormControl,
  Checkbox,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Divider,
  Fab,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { styled } from "@mui/material/styles";
import { getFirmData } from "../companyformdata";
import axios from "axios";
import config from "../config";

const AccountingFirm = () => {
  const {
    firmFieldsData,
    firmTypeOptions,
    businessInfoFields,
    operationalInfo,
    ownerInfoFields,
    directorInfoFields,
    taxInfoFields,
    bankingInfoFields,
    registrationInfoFields,
    supportingDocumentsFields,
  } = getFirmData();

  const [gridItems, setGridItems] = useState([
    { name: "", nationality: "", percentageofownership: "", contact: "" },
  ]);

  const [firmType, setFirmType] = useState("");
  const [firmFormData, setFirmFormData] = useState({
    firmInfo: {},
    businessInfo: {},
    operationalInfo: {},
    ownerInfo: [
      { name: "", percentageofownership: "", nationality: "", contact: "" },
    ],
    directors: [{ name: "", position: "", nationality: "", contact: "" }],
    taxInfo: {},
    bankingInfo: {},
    registrationInfo: {},
    documents: [],
  });

  const [otherValue, setOtherValue] = useState("");

  const [directors, setDirectors] = useState([
    { name: "", position: "", nationality: "", contact: "" },
  ]);

  const { API_BASE_URL } = config;

  const handleAddItem = () => {
    setGridItems([
      ...gridItems,
      { name: "", nationality: "", percentageofownership: "", contact: "" },
    ]);
  };

  const handleDirectorAdd = () => {
    setDirectors([
      ...directors,
      { name: "", position: "", nationality: "", contact: "" },
    ]);
  };

  const handleChange = (event) => {
    setFirmType(event.target.value);
    if (event.target.value !== "other") {
      setOtherValue(""); 
    }
  };

  const handleOtherChange = (event) => {
    
    setOtherValue(event.target.value);
  };

  const handleInputChange = (section, index, field, value) => {
    const updatedValues = { ...firmFormData };
    if (section === "ownerInfo" || section === "directors") {
      updatedValues[section][index][field] = value;
    } else {
      updatedValues[section][field] = value;
    }

    setFirmFormData(updatedValues);
  };

  const handleaccountingClick = async (e) => {
    const dataToSend = {
      firmType,
      otherValue,
      ...firmFormData,
    };

    try {
      const response = await axios.post(`${API_BASE_URL}/api/v1/kyc`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) {
       
        
      } else {
        console.error("Submission failed:", response.data.message);
        
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      
    }
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));
  return (
    <Box
      sx={{ flexGrow: 1, marginBottom: "10px", marginTop: "70px" }}
      className="w-100"
    >
      <Grid
        container
        spacing={2}
        justifyContent="flex-center"
        className="justify-content-center mt-3"
      >
        <Grid item xs={10} className="">
          <Box
            sx={{
              padding: "16px",
              background:
                "linear-gradient(90deg, rgba(181,178,235,1) 10%, rgba(189,206,247,1) 35%, rgb(251 172 101 / 99%) 80%)",
            }}
          >
            <h5 className="fw-bold">Firm Information</h5>
            <Grid container spacing={2} direction="row" className="pb-3">
              {firmFieldsData.slice(0, 3).map((firminfo) => {
                return (
                  <Grid item xs={4} key={firminfo.id}>
                    <TextField
                      fullWidth
                      placeholder={firminfo.placeholder}
                      variant="outlined"
                      value={firmFormData.firmInfo[firminfo.id] || ""}
                      
                      onChange={(e) =>
                        handleInputChange(
                          "firmInfo",
                          null,
                          firminfo.id,
                          e.target.value
                        )
                      }
                      sx={{
                        border: "1px solid grey",
                        borderRadius: "6px",
                        fontSize: "0.7rem",
                      }}
                    />
                  </Grid>
                );
              })}
              <div className="d-flex align-items-center">
                <FormControl component="fieldset">
                  <p className="fw-bold text-start ms-3 mt-3 mb-0">
                    Firm Type:
                  </p>
                  <RadioGroup
                    aria-label="company-type"
                    name="company-type"
                    value={firmType}
                    className="ms-3"
                    onChange={handleChange}
                    row 
                  >
                    {firmTypeOptions.map((firmtype) => {
                      return (
                        <FormControlLabel
                          value={firmtype.value}
                          control={<Radio />}
                          label={firmtype.label}
                        />
                      );
                    })}
                    <FormControlLabel
                      value="other"
                      control={<Radio />}
                      label={
                        <>
                          Other (Please Specify):
                          <TextField
                            id="standard-basic"
                            value={otherValue}
                            onChange={handleOtherChange}
                            variant="standard"
                            size="small"
                            style={{ marginLeft: 8 }}
                          />
                        </>
                      }
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <p className="fw-bold text-start ms-3 mt-3 mb-0 w-100">
                Registration Details:
              </p>
              {firmFieldsData.slice(3, 6).map((firminfo) => {
                return (
                  <Grid item xs={4} key={firminfo.id}>
                    <TextField
                      fullWidth
                      placeholder={firminfo.placeholder}
                      variant="outlined"
                      className="d-block"
                      value={firmFormData.firmInfo[firminfo.id] || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "firmInfo",
                          null,
                          firminfo.id,
                          e.target.value
                        )
                      }
                      sx={{
                        border: "1px solid grey",
                        borderRadius: "6px",
                        fontSize: "0.7rem",
                      }}
                    />
                  </Grid>
                );
              })}
              <p className="fw-bold text-start ms-3 mt-3 mb-0 w-100">
                Firm Address:
              </p>
              {firmFieldsData.slice(6, 12).map((firminfo) => {
                return (
                  <Grid item xs={4} key={firminfo.id}>
                    <TextField
                      fullWidth
                      placeholder={firminfo.placeholder}
                      variant="outlined"
                      value={firmFormData.firmInfo[firminfo.id] || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "firmInfo",
                          null,
                          firminfo.id,
                          e.target.value
                        )
                      }
                      sx={{
                        border: "1px solid grey",
                        borderRadius: "6px",
                        fontSize: "0.7rem",
                      }}
                    />
                  </Grid>
                );
              })}
              <p className="fw-bold text-start ms-3 mt-3 mb-0 w-100">
                Contact Information:
              </p>
              {firmFieldsData.slice(12).map((firminfo) => {
                return (
                  <Grid item xs={4} key={firminfo.id}>
                    <TextField
                      fullWidth
                      placeholder={firminfo.placeholder}
                      variant="outlined"
                      value={firmFormData.firmInfo[firminfo.id] || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "firmInfo",
                          null,
                          firminfo.id,
                          e.target.value
                        )
                      }
                      sx={{
                        border: "1px solid grey",
                        borderRadius: "6px",
                        fontSize: "0.7rem",
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Divider
              variant="middle"
              className="mt-3 mb-3"
              sx={{ borderBottomWidth: "2px", borderColor: "#0454bf" }}
            />
            <h5 className="fw-bold">Business Information</h5>
            <Grid container spacing={2} alignItems="center">
              {businessInfoFields.map((businessinfo) => {
                return (
                  <Grid item xs={4} key={businessinfo.id}>
                    <TextField
                      fullWidth
                      placeholder={businessinfo.placeholder}
                      variant="outlined"
                      value={firmFormData.businessInfo[businessinfo.id] || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "businessInfo",
                          null,
                          businessinfo.id,
                          e.target.value
                        )
                      }
                      sx={{
                        border: "1px solid grey",
                        borderRadius: "6px",
                        fontSize: "0.7rem",
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Divider
              variant="middle"
              className="mt-4 mb-3"
              sx={{ borderBottomWidth: "2px", borderColor: "#0454bf" }}
            />
            <h5 className="fw-bold">Operational Information</h5>
            <Grid container spacing={2} alignItems="center">
              {operationalInfo.map((operationinfo) => {
                return (
                  <Grid item xs={4} key={operationinfo.id}>
                    <TextField
                      fullWidth
                      placeholder={operationinfo.placeholder}
                      variant="outlined"
                      value={
                        firmFormData.operationalInfo[operationinfo.id] || ""
                      }
                      onChange={(e) =>
                        handleInputChange(
                          "operationalInfo",
                          null,
                          operationinfo.id,
                          e.target.value
                        )
                      }
                      sx={{
                        border: "1px solid grey",
                        borderRadius: "6px",
                        fontSize: "0.7rem",
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Divider
              variant="middle"
              className="mt-4 mb-3"
              sx={{ borderBottomWidth: "2px", borderColor: "#0454bf" }}
            />
            <h5 className="fw-bold">Ownership Information</h5>
            <Grid container spacing={2} alignItems="center">
              <h6 className="fw-bold text-start w-100 mt-3 ms-3">
                Partners/Owners:
              </h6>
              <p className="fw-bold text-start w-100 ms-3 mb-0">
                List of Partners/Owners
              </p>
              {firmFormData.ownerInfo.map((item, index) => (
                <React.Fragment key={index}>
                  {ownerInfoFields.map((ownerinfo, i) => (
                    <Grid item xs={3} key={`${ownerinfo.category}-${i}`}>
                      <TextField
                        fullWidth
                        placeholder={ownerinfo.placeholder}
                        variant="outlined"
                        value={item[ownerinfo.id]}
                        onChange={(e) =>
                          handleInputChange(
                            "ownerInfo",
                            index,
                            ownerinfo.id,
                            e.target.value
                          )
                        }
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  ))}
                </React.Fragment>
              ))}
              <Fab
                color="secondary"
                aria-label="add"
                className="mt-2 ms-3"
                sx={{ height: "20px", width: "35px" }}
                onClick={handleAddItem}
              >
                <AddIcon className="" />
              </Fab>

              <h6 className="fw-bold text-start w-100 mt-3 ms-3">
                Key Management Personnel
              </h6>
              <p className="fw-bold text-start w-100 ms-3 mb-0">
                List of Key Management Personnel:
              </p>
              {directors.map((director, index) => (
                <React.Fragment key={index}>
                  {directorInfoFields.map((info, i) => (
                    <Grid item xs={3} key={`${info.category}-${i}`}>
                      <TextField
                        fullWidth
                        placeholder={info.placeholder}
                        variant="outlined"
                        value={director[info.id]}
                        onChange={(e) =>
                          handleInputChange(
                            "directors",
                            index,
                            info.id,
                            e.target.value
                          )
                        }
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  ))}
                </React.Fragment>
              ))}
              <Fab
                color="secondary"
                aria-label="add"
                className="mt-2 ms-3"
                sx={{ height: "20px", width: "35px" }}
                onClick={handleDirectorAdd}
              >
                <AddIcon className="" />
              </Fab>
            </Grid>
            <Divider
              variant="middle"
              className="mt-4 mb-3"
              sx={{ borderBottomWidth: "2px", borderColor: "#0454bf" }}
            />
            <h5 className="fw-bold mt-3">Tax Information</h5>
            <Grid container spacing={2} alignItems="center">
              {taxInfoFields.map((taxinfo, index) => (
                <React.Fragment key={taxinfo.id}>
                  {taxinfo.id === "amlComplianceImplemented" && (
                    <h6 className="fw-bold text-start w-100 mt-3 ms-3">
                      Anti-Money Laundering (AML) Compliance:
                    </h6>
                  )}

                  {taxinfo.type === "radio" ? (
                    <Grid item {...taxinfo.grid}>
                      <Typography
                        component="p"
                        className="ms-0"
                        sx={{
                          fontSize: "0.9rem",
                        }}
                      >
                        {taxinfo.placeholder}
                      </Typography>
                      <RadioGroup row>
                        {taxinfo.options.map((option) => (
                          <FormControlLabel
                            key={option.value}
                            value={option.value}
                            control={<Radio />}
                            label={option.label}
                            sx={{ fontSize: "0.7rem" }}
                          />
                        ))}
                      </RadioGroup>
                    </Grid>
                  ) : (
                    <Grid item {...taxinfo.grid} xs={4}>
                      <TextField
                        fullWidth
                        placeholder={taxinfo.placeholder}
                        variant="outlined"
                        type={taxinfo.type}
                        value={firmFormData.taxInfo[taxinfo.id] || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "taxInfo",
                            null,
                            taxinfo.id,
                            e.target.value
                          )
                        }
                        sx={{
                          border: "1px solid grey",
                          borderRadius: "6px",
                          fontSize: "0.7rem",
                        }}
                      />
                    </Grid>
                  )}
                </React.Fragment>
              ))}
            </Grid>
            <Divider
              variant="middle"
              className="mt-4 mb-3"
              sx={{ borderBottomWidth: "2px", borderColor: "#0454bf" }}
            />
            <h5 className="fw-bold mt-">Banking Information</h5>
            <Grid container spacing={2} alignItems="center">
              {bankingInfoFields.map((bankinginfo, index) => {
                return (
                  <Grid item xs={4} key={bankinginfo.id}>
                    <TextField
                      fullWidth
                      placeholder={bankinginfo.placeholder}
                      variant="outlined"
                      value={firmFormData.bankingInfo[bankinginfo.id] || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "bankingInfo",
                          null,
                          bankinginfo.id,
                          e.target.value
                        )
                      }
                      sx={{
                        border: "1px solid grey",
                        borderRadius: "6px",
                        fontSize: "0.7rem",
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Divider
              variant="middle"
              className="mt-4 mb-3"
              sx={{ borderBottomWidth: "2px", borderColor: "#0454bf" }}
            />
            <h5 className="fw-bold">Professional Information</h5>
            <p className="fw-bold float-start">Professional Registration:</p>
            <Grid container spacing={2}>
              {registrationInfoFields.map((registrationinfo) => {
                return (
                  <Grid item xs={3} key={registrationinfo.id}>
                    <TextField
                      fullWidth
                      placeholder={registrationinfo.placeholder}
                      name={registrationinfo.id}
                      value={
                        firmFormData.registrationInfo[registrationinfo.id] || ""
                      }
                      onChange={(e) =>
                        handleInputChange(
                          "registrationInfo",
                          null,
                          registrationinfo.id,
                          e.target.value
                        )
                      }
                      variant="outlined"
                      sx={{
                        border: "1px solid grey",
                        borderRadius: "6px",
                        fontSize: "0.7rem",
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <h6 className="fw-bold text-start w-100 mt-4 mb-3">
              Supporting Documents
            </h6>
            <Grid container spacing={2} alignItems="center">
              {/* Documents Required */}
              <p className="fw-bold text-start w-100 ms-3 mb-0">
                Documents Required:
              </p>
              {supportingDocumentsFields.map((doc, index) => {
                
                return (
                  <Grid item xs={6} key={doc.id} className="text-start">
                    <FormControlLabel
                      control={<Checkbox name={doc.id} />}
                      label={doc.label}
                      value={firmFormData.documents[doc.id] || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "documents",
                          null,
                          doc.id,
                          e.target.value
                        )
                      }
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Divider
              variant="middle"
              className="mt-4 mb-3"
              sx={{ borderBottomWidth: "2px", borderColor: "#0454bf;" }}
            />
            <Button onClick={handleaccountingClick}>
              <Fab
                variant="extended"
                size="small"
                sx={{
                  width: "100px",
                  height: "25px",
                  backgroundColor: "#e7c305",
                }}
              >
                <span style={{ fontSize: "0.6rem" }} className="fw-bold">
                  Submit
                </span>
              </Fab>
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AccountingFirm;
